module.exports = __webpack_public_path__ + "fonts/segoe_ui-webfont.36bfc3c.woff2";